import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Absence, AbsenceRejectRequest } from 'src/app/_model/Absence';
import { AbsenceService } from 'src/app/_services/absence.service';
import { RequestService } from "../../_services/request.service";
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LookupService } from '../../_services/lookup.service';
import { Requests, RequestsRejectRequest } from "../../_model/Requests";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
@Component({
    selector: 'app-requestsreject',
    templateUrl: './requestsreject.component.html',
    styleUrls: ['./requestsreject.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatInputModule,
        MatOptionModule,
        MatDialogModule
    ]
})
export class RequestrejectComponent implements OnInit {

    request: RequestsRejectRequest = new RequestsRejectRequest();
    currentUser: User;
    selectedRejectReason: any = {};
    rejectReasons: any[];
    rejectDescription = '';

    constructor(public dialogRef: MatDialogRef<RequestrejectComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests,
        private authService: AuthenticationService,
        private requestService: RequestService,
        private toastr: ToastrService,
        private lookupService: LookupService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
        this.rejectReasons = this.lookupService.localRejectReasonLookupList();
    }

    rejectRequest(ruquests: Requests) {
        this.request.employeeId = this.currentUser.employeeId;
        this.request.operationRecordId = ruquests.id;
        this.request.operationTableName = 'REQUESTS';
        this.request.rejectDescription = this.rejectDescription;
        this.request.rejectReasonId = this.selectedRejectReason.id;

        this.requestService.rejectRequests(this.request).subscribe(result => {
            this.toastr.success('reddetme işlemi başarılı', '');
            this.dialogRef.close(true);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close(false);
        });
    }
}
